import {
  ExclamationCircleIcon,
  EyeIcon,
  EyeOffIcon,
} from "@heroicons/react/solid";
import i18next from "i18next";
import { useMemo, useState } from "react";
import InputErrors from "./InputErrors";
import "./formStyle.css";

type AppInputProps = {
  id?: string;
  label?: string;
  type?: string;
  name?: string;
  patternError?: string;
  className?: string;
  placeholder?: string;
  defaultValue?: any;
  value?: any;
  error?: any;
  children?: React.ReactNode;
  autoComplete?: string;
  hideLabel?: boolean;
  scehema: any;
  register: any;
  disabled?: boolean;
  max?: string;
  descriptiveLabel?: string;
  cypressSelector?: string;
};

export default function AppInput({
  id,
  label,
  type,
  name,
  className,
  placeholder,
  defaultValue,
  value,
  error,
  autoComplete,
  scehema,
  register,
  patternError,
  hideLabel = false,
  disabled,
  max,
  descriptiveLabel,
  cypressSelector,
}: AppInputProps) {
  const [show, setShow] = useState(false);
  const isRequired = useMemo(() => {
    if (!!scehema) {
      return !!scehema["required"];
    }
    return false;
  }, [scehema]);

  return (
    <div className="w-full">
      {!!label && !hideLabel && (
        <label
          htmlFor={id}
          className={"block text-sm font-medium text-gray-700 mb-1"}
        >
          {`${label}${isRequired ? " *" : ""}`}
        </label>
      )}
      <div className="relative rounded-md shadow-sm">
        <input
          disabled={!!disabled}
          max={max}
          {...register(name, scehema)}
          type={type === "password" ? (show ? "text" : "password") : type}
          name={name}
          autoComplete={autoComplete}
          id={id}
          className={` focus:ring-brandblue-500 focus:border-brandblue-500 block w-full rtl:pl-10 ltr:pr-10 text-sm border-gray-300 rounded-md ${className} ${
            error && "ring-red-600 focus:ring-red-600 focus:border-red-600"
          } ${disabled ? "bg-gray-100" : ""}${
            descriptiveLabel ? "hide-input-arrows" : ""
          }`}
          placeholder={placeholder}
          defaultValue={defaultValue}
          value={value}
          aria-invalid="true"
          data-cy={cypressSelector}
          aria-describedby="email-error"
        />
        {!!descriptiveLabel && (
          <div className="absolute z-[100] bg-white inset-y-1  rtl:left-2 ltr:right-2 ltr:pr-2 rtl:pl-2 flex items-center">
            <p className="mx-auto text-gray-500 capitalize">
              {descriptiveLabel}
            </p>
          </div>
        )}
        {type === "password" && (
          <div className="absolute z-[100] inset-y-0 h-10 w-10 rtl:left-0 ltr:right-0 ltr:pr-2 rtl:pl-2 flex items-center">
            <button
              className="mx-auto"
              type="button"
              onClick={() => {
                setShow(!show);
              }}
            >
              {!show ? (
                <div>
                  <EyeOffIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </div>
              ) : (
                <div>
                  <EyeIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </div>
              )}
            </button>
          </div>
        )}
        {error && (
          <div
            className={`absolute inset-y-0 rtl:left-0 ltr:right-0  ${
              type === "password" ? "ltr:pr-10 rtl:pl-10" : "ltr:pr-3 rtl:pl-3"
            } flex items-center pointer-events-none`}
          >
            <ExclamationCircleIcon
              className="h-5 w-5 text-red-500"
              aria-hidden="true"
            />
          </div>
        )}
      </div>
      {InputErrors(error, scehema, patternError, label)}
    </div>
  );
}
